<molecule-avatar-info-dumb
    [avatar]="avatar"
    [partyAvatarInfo]="partyAvatarInfo$ | ngrxPush"
    [partyAvatarInfoIsLoading]="partyAvatarInfoIsLoading$ | ngrxPush"
    [partyAvatarInfoHasLoadingError]="
        partyAvatarInfoHasLoadingError$ | ngrxPush
    "
    [editModalId]="editModalId"
></molecule-avatar-info-dumb>
